/* @ngInject */
function userFiltersService (CONSTANTS, ConnectorWebService, Utils) {
  var service = {
    convertFiltersToArray,
    setFilterLabels,
    getUserFilters,
    createUserFilter,
    updateUserFilter,
    deleteUserFilter,
    getFiltersWithValue
  }

  function getFilterLabel (filterName, value, allFilters) {
    const selectedFilter = allFilters.find(item => item.name === filterName)
    let optionLabel = ''
    let filterLabel = ''

    const creationDateFilters = ['createdAtStart', 'createdAtEnd']
    const deliveryDateFilters = ['deliveryDateStart', 'deliveryDateEnd']

    if (selectedFilter) {
      filterLabel = selectedFilter.props.label
      const filterValue = Array.isArray(value) ? value[0] : value
      if (selectedFilter.props.options) {
        const selectedOption = selectedFilter.props.options.find(item => item.value.toString() === filterValue.toString())

        if (selectedOption) {
          optionLabel = selectedOption.label
        }
      }
    } else if (!selectedFilter && creationDateFilters.includes(filterName)) {
      return getFilterLabel('createdAtRange', value, allFilters)
    } else if (!selectedFilter && deliveryDateFilters.includes(filterName)) {
      return getFilterLabel('deliveryDateRange', value, allFilters)
    }

    return {
      optionLabel,
      filterLabel
    }
  }

  function convertFiltersToArray (filters, allFilters) {
    const filtersArray = []
    for (const key in filters) {
      const value = filters[key]
      const isArray = Array.isArray(value)
      const arrayHasItems = isArray && value.length > 0
      const valueNotEmpty = value !== null && value !== '' && value !== undefined

      if (valueNotEmpty && (!isArray || arrayHasItems)) {
        const { optionLabel, filterLabel } = getFilterLabel(key, value, allFilters)

        filtersArray.push({
          filter: key,
          value,
          optionLabel,
          filterLabel
        })
      }
    }
    return filtersArray
  }

  function setFilterLabels (filterArray, allFilters) {
    filterArray.forEach(filter => {
      const value = filter.value
      const isArray = Array.isArray(value)
      const arrayHasItems = isArray && value.length > 0
      const valueNotEmpty = value !== null && value !== '' && value !== undefined

      if (valueNotEmpty && (!isArray || arrayHasItems)) {
        const { optionLabel, filterLabel } = getFilterLabel(filter.filter, value, allFilters)

        filter.optionLabel = optionLabel
        filter.filterLabel = filterLabel
      }
    })

    return filterArray
  }

  function sanitizeFilters (filters) {
    const arrayFilters = ['type', 'priorities', 'status', 'tags', 'form', 'authors', 'assignees', 'taskStatus', 'groups']

    filters.forEach(filter => {
      if (Array.isArray(filter.filterItems)) {
        filter.filterItems.forEach(item => {
          if (arrayFilters.includes(item.filter) && typeof item.value === 'string') {
            item.value = item.value.split(',')
          }
        })
      }
    })

    return filters
  }

  function getUserFilters (location) {
    let url = CONSTANTS.URL_USER_FILTERS

    if (location) {
      url = Utils.fnAddQueryToUrl(url, { location })
    }

    return ConnectorWebService.get(url).then(sanitizeFilters)
  }

  function createUserFilter (body) {
    const url = CONSTANTS.URL_USER_FILTERS

    return ConnectorWebService.post(url, body)
  }

  function updateUserFilter (id, body) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_USER_FILTERS_ID, [id])

    return ConnectorWebService.put(url, body)
  }

  function deleteUserFilter (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_USER_FILTERS_ID, [id])

    return ConnectorWebService.fnDelete(url)
  }

  function getFiltersWithValue (filters) {
    return Object.keys(filters).filter(key => filters[key] !== null && filters[key] !== undefined && filters[key] !== '' && filters[key].length !== 0)
  }

  return service
}

export { userFiltersService }
